import React from 'react';
import { formatPercent } from '../lib/executiveCommandCenterFormatters';

const Stat = ({ label, value, tone = 'text-slate-100' }) => (
  <div className="rounded-lg border border-slate-800 bg-slate-950/70 p-3">
    <div className="text-xs text-slate-400">{label}</div>
    <div className={`mt-1 text-lg font-semibold ${tone}`}>{value}</div>
  </div>
);

const NetworkServiceHealthPanel = ({ data }) => {
  const info = data || {};
  const severity = info.incident_counts_by_severity || {};
  const areas = Array.isArray(info.top_risk_areas) ? info.top_risk_areas : [];

  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/60 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Network & Service Health</h3>
      <div className="mt-3 grid gap-3 md:grid-cols-3 xl:grid-cols-6">
        <Stat label="Affected Customers" value={Number(info.affected_customers || 0)} tone="text-amber-200" />
        <Stat label="Area Incidents" value={Number(info.active_area_incidents || 0)} tone="text-red-300" />
        <Stat label="ONU_UP_PPP_DOWN" value={Number(info.onu_up_ppp_down_cases || 0)} tone="text-amber-300" />
        <Stat label="Recovery Success" value={formatPercent(info.recovery_success_rate)} tone="text-emerald-200" />
        <Stat label="Service Availability" value={formatPercent(info.service_availability)} tone="text-cyan-200" />
        <Stat label="Critical Incidents" value={Number(severity.CRITICAL || 0)} tone="text-rose-300" />
      </div>

      <div className="mt-4 grid gap-3 md:grid-cols-4">
        <Stat label="Severity HIGH" value={Number(severity.HIGH || 0)} tone="text-amber-300" />
        <Stat label="Severity MEDIUM" value={Number(severity.MEDIUM || 0)} tone="text-blue-300" />
        <Stat label="Severity LOW" value={Number(severity.LOW || 0)} tone="text-emerald-300" />
        <Stat label="Severity CRITICAL" value={Number(severity.CRITICAL || 0)} tone="text-red-300" />
      </div>

      <div className="mt-4 rounded-lg border border-slate-800 bg-slate-950/70 p-3">
        <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-400">Top Risk Areas</div>
        <div className="grid gap-2 md:grid-cols-2">
          {areas.slice(0, 6).map((item) => (
            <div key={item.area_name} className="flex items-center justify-between rounded-md border border-slate-800 bg-slate-900/80 px-2 py-1.5 text-xs">
              <span className="text-slate-300">{item.area_name}</span>
              <span className="font-semibold text-amber-200">{Number(item.affected_customers || 0)} affected</span>
            </div>
          ))}
          {areas.length === 0 ? <div className="text-xs text-slate-500">Belum ada area risiko tinggi.</div> : null}
        </div>
      </div>
    </section>
  );
};

export default NetworkServiceHealthPanel;
